import { render, staticRenderFns } from "./HallOfFameView.vue?vue&type=template&id=64459555&scoped=true&"
import script from "./HallOfFameView.vue?vue&type=script&lang=js&"
export * from "./HallOfFameView.vue?vue&type=script&lang=js&"
import style0 from "./HallOfFameView.vue?vue&type=style&index=0&id=64459555&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64459555",
  null
  
)

export default component.exports